import React, { useState, useEffect } from "react";
import { clanicData, createInvoicesCsv } from "../../utils/helpers";
import { Select, Table, Button, Empty } from 'antd'
import { useSelector } from "react-redux";
import { allDesigns } from "../../utils/constants";
const { Option } = Select

const ContactData = (props) => {
    const { selectedLanguage, userActions, user } = props;
    const contactData = useSelector(state => state?.userReducer?.allContactforms)
    const [selectedDesign, setSeletedDesign] = useState(allDesigns?.[0]?.val)
    const filteredContactData = contactData?.filter((v) => v?.designName === selectedDesign)

    let columns = [
        {
            title: <p className='column-label'>{selectedLanguage?.name_label}</p>,
            dataIndex: 'name',
            render: (e) => <>{e ? e : '__________'}</>
        },
        {
            title: <p className='column-label'>{selectedLanguage?.input_email_placeholder}</p>,
            dataIndex: 'email',
        },
        {
            title: <p className='column-label'>{selectedLanguage?.txt_number}</p>,
            dataIndex: 'number',
        },
        {
            title: <p className='column-label'>{selectedLanguage?.txt_postal_code}</p>,
            dataIndex: 'postCode',
            render: (e) => <>{e ? e : '__________'}</>
        },
        {
            title: <p className='column-label'>{selectedLanguage?.input_message_placeholder}</p>,
            dataIndex: 'message',
            render: (e) => <>{e ? e : '__________'}</>
        },
    ]

    const changeSelectedDesign = (e) => {
        setSeletedDesign(e)
    }

    useEffect(() => {
        clanicData?.getAllContactForm(userActions, user?._id)
    }, [])

    return (
        <div className="main">
            <div>
                <div className="service-top-div" style={{ margin: '0px' }}>
                    <div>
                        <h1>{selectedLanguage?.txt_contact_data}</h1>
                    </div>
                </div>
                <div className="appointment-form-container">
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Select
                            notFoundContent={
                                <Empty description={selectedLanguage?.No_data} image={Empty.PRESENTED_IMAGE_SIMPLE} />
                            }
                            showArrow
                            style={{ width: 250, margin: '10px 0px' }}
                            defaultValue={selectedDesign}
                            onChange={changeSelectedDesign}
                            className='form-input'
                            showSearch
                            optionFilterProp='children'
                        >
                            {allDesigns?.map((v, i) => <Option value={v?.val} key={i}>{v?.name}</Option>)}
                        </Select>
                        <Button
                            type='primary'
                            className='btn-end'
                            style={{ width: '140px', margin: '10px 0px', background: '#61cee5' }}
                            onClick={() => createInvoicesCsv(filteredContactData, selectedLanguage)}
                        >
                            {selectedLanguage?.txt_DownloadCSV}
                        </Button>
                    </div>
                    <Table
                        className='new-layout-table'
                        columns={columns}
                        dataSource={filteredContactData}
                        pagination={{ hideOnSinglePage: true }}
                        scroll={{ x: 'auto', y: '550px' }}
                    />
                </div>
            </div>
        </div>
    )
}

export default ContactData